export default __webpack_public_path__ + "static/media/planet.f39f316d.png";